import { EbizioEvent, EbizioEventConfig, EBIZIO_EVENT_TYPE } from '../types';
import { logger } from '../utils';
import { combineAndMergeFees } from '../custom';

export const billingStepLoadingHandler = (event: EbizioEvent) => {
  logger('Billing Step Loading');
  console.log(event.detail);

  combineAndMergeFees(event.detail);
};

export const billingStepLoadingConfig: EbizioEventConfig = {
  event: EBIZIO_EVENT_TYPE.BILLING_STEP_LOADING,
  handler: billingStepLoadingHandler,
};
